<div class="programme-page">
  <app-header-style-seven></app-header-style-seven>

  <section class="page-shell programme-page-shell">
    <div class="custom-container">
      <div class="content-shell programme-shell">
        <header class="program-header">
          <span class="program-kicker">Academics</span>
          <h1>Programme Offered</h1>
          <p>
            Explore our undergraduate, postgraduate, management, and research
            programmes.
          </p>
        </header>

        <section class="program-section">
          <article class="program-category">
            <div class="category-head">
              <h2>Undergraduate Programmes (UG)</h2>
              <p>Bachelor of Engineering</p>
            </div>

            <div class="program-boxes">
              <div class="program-box">
                <a routerLink="/civil" class="program-link">B.E Civil Engineering</a>
              </div>

              <div class="program-box">
                <a routerLink="/cse" class="program-link">B.E  Computer Science &amp; Engineering</a>
              </div>

              <div class="program-box">
                <a routerLink="/ai" class="program-link">
                  B.E Computer Science (Artificial Intelligence &amp; Machine Learning)
                </a>
              </div>

              <div class="program-box">
                <a routerLink="/ai" class="program-link">
                  B.Tech. Artificial Intelligence &amp; Data Science
                </a>
              </div>

              <div class="program-box">
                <a routerLink="/cs" class="program-link">B.E Computer Science (Cyber Security)</a>
              </div>

              <div class="program-box">
                <a routerLink="/ece" class="program-link">B.E Electronics &amp; Communication Engineering</a>
              </div>

              <div class="program-box">
                <a routerLink="/eee" class="program-link">B.E Electrical &amp; Electronics Engineering</a>
              </div>

              <div class="program-box">
                <a routerLink="/mech" class="program-link">B.E Mechanical Engineering</a>
              </div>
            </div>
          </article>

       <!-- Postgraduate Programmes (PG) -->
<article class="program-category">
  <div class="category-head">
    <h2>Postgraduate Programmes (PG)</h2>
    <p>Master of Engineering</p>
  </div>

  <div class="program-boxes">
    <div class="program-box">
      <a routerLink="/cse" class="program-link">M.E Computer Science & Engineering</a>
    </div>

    <div class="program-box">
      <a routerLink="/eee" class="program-link">M.E Embedded System Technologies</a>
    </div>

    <div class="program-box">
      <a routerLink="/mech" class="program-link">M.E Thermal Engineering</a>
    </div>

    <div class="program-box">
      <a routerLink="/civil" class="program-link">M.E Environmental Engineering</a>
    </div>
  </div>
</article>

<!-- Postgraduate Programme in Management (PG) -->
<article class="program-category">
  <div class="category-head">
    <h2>Postgraduate Programme in Management (PG)</h2>
    <p>Management Programme</p>
  </div>

  <div class="program-boxes">
    <div class="program-box">
      <a routerLink="/mba" class="program-link">Master of Business Administration</a>
    </div>
  </div>
</article>

       
<article class="program-category">
  <div class="category-head">
    <h2>Research Programme</h2>
    <p>Part Time &amp; Full Time</p>
  </div>

  <div class="program-boxes">
    <div class="program-box">
      <a routerLink="/mech" class="program-link">Ph.D - Mechanical Engineering</a>
    </div>
  </div>
</article>
        </section>
      </div>
    </div>
  </section>
</div>